import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Modal (web) del DS: 640 px, radio 32. Header (título + 1 línea + cerrar) · contenido · footer con acciones.
 * En celular se muestra a pantalla completa con el footer fijo abajo (estilos globales `.cr-modal`).
 */
@Component({
  selector: 'app-modal-frame',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cr-modal">
      <header class="cr-modal__head">
        <div class="cr-modal__titles">
          <h2 class="cr-modal__title">{{ title() }}</h2>
          @if (subtitle()) { <p class="cr-modal__subtitle">{{ subtitle() }}</p> }
        </div>
        <button type="button" class="cr-icon-btn" aria-label="Cerrar" (click)="closed.emit()"><cr-icon name="x" [size]="18" /></button>
      </header>
      <div class="cr-modal__body"><ng-content /></div>
      <footer class="cr-modal__foot"><ng-content select="[modal-footer]" /></footer>
    </div>
  `,
})
export class ModalFrameComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>('');
  readonly closed = output<void>();
}
